/* eslint-disable no-unused-vars */
/**
 * Provides a single instace of the API consumer for use by various actions in
 * the Vuex store
 * @file 
 * @author Benjamin Listwon
 */
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { get as idbGet } from 'idb-keyval'
import { VUEX_AUTH_LOGOUT } from '@/store/constants/auth'

/**
 * An instance of the Kitsu jsonapi consumer.
 * @constant
 * @type {object}
 */
const api = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL
})

/**
 * A custom axios interceptor. The function wraps every error response and
 * when a 401 Unathorized is detected it will dispatch a Vuex action to invalidate the
 * local app user, then redirect to login.
 * 
 * @function
 */
// 
api.interceptors.response.use((response) => {
	return response
}, function (error) {

	if (error.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		console.error(error.response.data)
		console.error(error.response.status)
		console.error(error.response.headers)

		if (error.response.status === 401) {
			store.dispatch(VUEX_AUTH_LOGOUT).then(() => {
				router.replace({ name: 'login' })
			})
		}

	} else if (error.request) {
		// The request was made but no response was received
		// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
		// http.ClientRequest in node.js
		console.error(error.request)
	} else {
		// Something happened in setting up the request that triggered an Error
		console.error('Error', error.message)
	}

	return Promise.reject(error);
})

if (idbGet(process.env.VUE_APP_SILA_2_USER_TOKEN)) {
	axios.defaults.headers.common['Authorization'] = 'Bearer ' + idbGet(process.env.VUE_APP_SILA_2_USER_TOKEN)
}

export default api
